// extracted by mini-css-extract-plugin
export default {"widget_container":"styles_widget_container__fUgRq","admin":"styles_admin__L7Trj","nonAdmin":"styles_nonAdmin__haOwR"};